// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { arbitrum as _arbitrum } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the arbitrum chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 42161
 * Chain Name: Arbitrum One
 * Default Block Explorer: https://arbiscan.io
 * Default RPC URL: https://arb1.arbitrum.io/rpc
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { arbitrum } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: arbitrum,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const arbitrum = createCommon({
	..._arbitrum,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
